export const ACTION_UPDATE_PRESET = 'ACTION_UPDATE_PRESET';
export const ACTION_RESET_PRESET = 'ACTION_RESET_PRESET';
export const ACTION_SHARE_PRESET = 'ACTION_SHARE_PRESET';
export const ACTION_UNSHARE_PRESET = 'ACTION_UNSHARE_PRESET';
export const ACTION_RENAME_PRESET = 'ACTION_RENAME_PRESET';
export const ACTION_DELETE_PRESET = 'ACTION_DELETE_PRESET';
export const ACTION_DUPLICATE_PRESET = 'ACTION_DUPLICATE_PRESET';
export const ACTION_CREATE_PRESET = 'ACTION_CREATE_PRESET';
